import {action, Action} from 'easy-peasy';

interface MetricTimelineType {
    id: number;
    name: string;
}

interface MetricTimelineTypesState {
    items: MetricTimelineType[];
    loadMetricTimelineTypes: Action<MetricTimelineTypesState, MetricTimelineType[]>;
}

const metricTimelineTypes: MetricTimelineTypesState = {
    items: [],
    loadMetricTimelineTypes: action((state, metricTimelineTypesList) => {
        state.items = metricTimelineTypesList;
    }),
};

export default metricTimelineTypes; 